// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/vendor.scss
// module id = ./resources/assets/sass/vendor.scss
// module chunks = 0